'use client';
import ArrowRight from '@/app/_components/ui/icons/ArrowRight.svg';
import Link from 'next/link';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function ProfileHeader({ title, link }) {
  const isMobile = useIsMobile();
  return (
    <>
      {!isMobile ? (
        <div className="pb-6 text-gray-700 flex ml-2">
          <h1 className="pr-2 text-base font-bold">{title}</h1>
        </div>
      ) : (
        <div className="pb-4 text-gray-700 flex items-center ml-2">
          <Link href={`${link ? link : '/profile'}`}>
            <span>
              <ArrowRight />
            </span>
          </Link>
          <h1 className="pr-2 text-base font-bold">{title} </h1>
        </div>
      )}
    </>
  );
}
